export default "__VITE_ASSET__7b4420bb__"